import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Package, Gift, ArrowRight, QrCode, BookOpen } from "lucide-react";
import wellnessBox from "@/assets/boxes/wellness-reset-box.png";

export default function TrainingBoxesSection() {
  return (
    <section className="py-16 bg-background">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-xs font-semibold text-primary uppercase tracking-[0.18em] mb-3">
              Physical + Digital Training Infrastructure
            </p>
            <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
              Training Boxes that unlock Callback Zone
            </h2>
            <p className="text-muted-foreground mb-6">
              CastReady Training Kits ship physical practice materials — scripts, lookbooks,
              and coach-curated guides — that pair with a redemption code. Redeem at
              checkout to unlock the matching curriculum, lessons, and feedback tools
              inside Callback Zone.
            </p>
            <ul className="space-y-3 mb-7">
              {[
                { icon: Package, text: "Coach-curated physical kit ships to your door" },
                { icon: QrCode,  text: "Scan or enter the code at checkout to redeem" },
                { icon: BookOpen, text: "Unlocks structured modules inside Callback Zone" },
              ].map(({ icon: Icon, text }) => (
                <li key={text} className="flex items-start gap-3">
                  <div className="w-8 h-8 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0">
                    <Icon className="w-4 h-4" />
                  </div>
                  <span className="text-sm text-foreground pt-1">{text}</span>
                </li>
              ))}
            </ul>
            <div className="flex flex-col sm:flex-row gap-3">
              <Button asChild size="lg" className="gap-2">
                <Link to="/training-kits">
                  Browse Training Kits
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="gap-2">
                <Link to="/redeem">
                  <Gift className="w-4 h-4" />
                  Redeem a Code
                </Link>
              </Button>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-square rounded-3xl bg-gradient-to-br from-primary/10 via-accent/5 to-secondary/10 p-8 flex items-center justify-center">
              <img
                src={wellnessBox}
                alt="CastReady Training Kit — physical box with coach-curated practice materials"
                className="max-w-full max-h-full object-contain drop-shadow-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}